module.exports = __webpack_public_path__ + "static/img/do-more-img-4-3.85264ba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/do-more-img-4-3.gif
// module id = 299
// module chunks = 1